import React, { useRef } from "react";
import { Editor } from "@tinymce/tinymce-react";

import Tiny from "../../playbooks/editor/modules/components/tinyMCE/Tiny";
import { get } from "lodash";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { classicStyle } from "./classicStyle";
import { pageViewStyle } from "./pageViewStyle";
import useNavBarTitle from "../../../../utils/hooks/useNavBarTitle";
import { useDispatch } from "react-redux";
import { saveAsset } from "../../../../utils/redux/actions/dataActions/assetActions";


export default function MainTextEditor() {
  let params = useParams();
  const data = useSelector((state) => state.v2Data);
  const asset = get(data, `assets.${params.assetId}`);
  const dispatch = useDispatch();


  const editorRef = useRef(null);
  const isSmallScreen = window.matchMedia("(max-width: 1023.5px)").matches;


  // Determine Page View Content Style
  const contentStyle = (editorView) => {
    if (editorView === "classicStyle") {
      return classicStyle;
    } else if (editorView === "pageViewStyle") {
      return pageViewStyle;
    } else {
      return classicStyle;
    }
  }

  // Blank document placeholder
  const blankDocument = '<h2 style="text-align: center;">&nbsp;</h2><h2 style="text-align: center;">&nbsp;</h2><p>&nbsp;</p><h2 style="text-align: center;">Welcome to the Sales Asset Editor 📝&nbsp;</h2><p>&nbsp;</p><p style="text-align: center;">To get started creating your content, use the AI-powered Quick Start Wizard on the left. Flight will create tailored content based on your product details and playbooks.</p><h3 class="LC20lb MBeuO DKV0Md" style="text-align: center;"><span style="font-size: 24pt; color: rgb(0, 0, 0);">⬅</span></h3>'

  return (
    <>
      <Editor
        apiKey="yo1kjdgnv2opj8sf3u9s7f8hhgquli8sfljw7xjlmvkxdnj7"
        onInit={(evt, editor) => (editorRef.current = editor)}
        onBlur={(e, editor) => {
          if (editorRef.current) {
            let content = editorRef.current.getContent();
            dispatch({
              type: "INSERT_CONTENT_INTO_CURRENT_ASSET",
              payload: {
                assetId: asset.id,
                content: content,
              },
            });
          }
        }}
        initialValue={asset.editingVersion.content ? asset.editingVersion.content : blankDocument}
        init={{
          selector: "textarea",
          plugins:
            "preview importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap pagebreak nonbreaking anchor insertdatetime advlist lists wordcount help charmap quickbars emoticons",
          editimage_cors_hosts: ["picsum.photos"],
          menubar: false,
          toolbar:
            "undo redo | bold italic underline strikethrough | fontfamily fontsize blocks | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | pagebreak | charmap emoticons | table code | fullscreen  preview save print | insertfile image media template link anchor codesample | ltr rtl",
          toolbar_sticky: true,
          resize: false,
          toolbar_sticky_offset: isSmallScreen ? 102 : 108,
          autosave_ask_before_unload: true,
          autosave_interval: "30s",
          autosave_prefix: "{path}{query}-{id}-",
          autosave_restore_when_empty: false,
          autosave_retention: "2m",
          image_advtab: true,
          link_list: [
            { title: "My page 1", value: "https://www.tiny.cloud" },
            { title: "My page 2", value: "http://www.moxiecode.com" },
          ],
          image_list: [
            { title: "My page 1", value: "https://www.tiny.cloud" },
            { title: "My page 2", value: "http://www.moxiecode.com" },
          ],
          image_class_list: [
            { title: "None", value: "" },
            { title: "Some class", value: "class-name" },
          ],
          importcss_append: true,
          file_picker_callback: (callback, value, meta) => {
            /* Provide file and text for the link dialog */
            if (meta.filetype === "file") {
              callback("https://www.google.com/logos/google.jpg", {
                text: "My text",
              });
            }

            /* Provide image and alt text for the image dialog */
            if (meta.filetype === "image") {
              callback("https://www.google.com/logos/google.jpg", {
                alt: "My alt text",
              });
            }

            /* Provide alternative source and posted for the media dialog */
            if (meta.filetype === "media") {
              callback("movie.mp4", {
                source2: "alt.ogg",
                poster: "https://www.google.com/logos/google.jpg",
              });
            }
          },
          templates: [
            {
              title: "New Table",
              description: "creates a new table",
              content:
                '<div class="mceTmpl"><table width="98%%"  border="0" cellspacing="0" cellpadding="0"><tr><th scope="col"> </th><th scope="col"> </th></tr><tr><td> </td><td> </td></tr></table></div>',
            },
            {
              title: "Starting my story",
              description: "A cure for writers block",
              content: "Once upon a time...",
            },
            {
              title: "New list with dates",
              description: "New List with dates",
              content:
                '<div class="mceTmpl"><span class="cdate">cdate</span><br><span class="mdate">mdate</span><h2>My List</h2><ul><li></li><li></li></ul></div>',
            },
          ],
          template_cdate_format: "[Date Created (CDATE): %m/%d/%Y : %H:%M:%S]",
          template_mdate_format: "[Date Modified (MDATE): %m/%d/%Y : %H:%M:%S]",
          height: "100%",
          branding: false,
          image_caption: true,
          quickbars_selection_toolbar:
            "bold italic | quicklink h2 h3 blockquote quickimage quicktable",
          noneditable_class: "mceNonEditable",
          toolbar_mode: "sliding",
          contextmenu: "link image table",
          skin: "tinymce-5",
          content_css: "default",
          content_style: contentStyle(asset.editorView),
        }}
      />
    </>
  );
}
